import styled from "styled-components";

const FormButton = styled.button<any>`
  cursor: pointer;
  padding: 0.4em 0.8em;
  background-color: ${(p) => p.theme.colors.dark};
  color: ${(p) => p.theme.colors.light};
  border-radius: 0;
  border: 0;
  outline: none;
  &:disabled {
    opacity: 0.6;
  }
`;

export default FormButton;
